var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.715 15.058Q15.12 9.654 19.256 7.933c7.877-3.277 9.514-3.846 10.58-3.864.236-.005.76.054 1.1.33.287.232.366.547.404.767.038.221.084.724.047 1.117-.427 4.485-2.274 15.369-3.213 20.392-.398 2.126-1.18 2.838-1.939 2.908-1.647.152-2.898-1.088-4.493-2.134-2.496-1.637-3.907-2.655-6.33-4.252-2.8-1.845-.985-2.86.611-4.517.418-.434 7.675-7.035 7.816-7.634.017-.075.033-.354-.133-.502-.165-.147-.41-.097-.587-.056q-.375.084-11.964 7.907-1.698 1.166-3.076 1.137c-1.012-.022-2.96-.573-4.409-1.044-1.776-.577-3.188-.883-3.065-1.863q.097-.766 2.11-1.567",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    rx: 6
  })))));
};
export default SvgTelegram;